<template>
  <div>
    <table
      class="mt-3 mb-1 table table-striped table-bordered table-sm"
      style="width:100%;font-size:.9rem;"
    >
      <thead>
        <tr>
          <th
            v-if="isOpen"
            class="align-middle text-center text-success cursor-pointer"
            rowspan="2"
            title="Aggiungi reddito"
            @click="apriForm()"
          >
            <font-awesome-icon
              icon="plus"
              class="cursor-pointer text-success"
            />
          </th>
          <th
            class="align-middle text-center pl-3"
            rowspan="2"
          >
            Nome e cognome
          </th>
          <th
            class="align-middle text-center pl-3"
            rowspan="2"
          >
            codice fiscale
          </th>
          <th
            class="align-middle text-center pl-3"
            rowspan="2"
          >
            relazione con assegnatario
          </th>
          <th
            class="align-middle text-center pl-3"
            rowspan="2"
          >
            Data entrata/uscita
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Totale<br>redditi
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            H
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(i,idx) in rows"
          :key="i.idx"
        >
          <td
            v-if="isOpen"
            class="align-middle text-center text-success"
            title="Modifica reddito"
            @click="apriForm(idx)"
          >
            <font-awesome-icon
              icon="pen"
              class="cursor-pointer text-success"
            />
          </td>
          <td class="align-middle text-left">
            {{ i.nome }} {{ i.cognome }}
          </td>
          <td class="align-middle text-left">
            {{ i.codiceFiscale }}
          </td>
          <td class="align-middle text-center">
            {{ i.relazioneAssegnatario.text }}
          </td>
          <td class="align-middle text-center">
            {{ i.dataInOut ? moment(i.dataInOut).format('DD/MM/YYYY') : '' }}
          </td>
          <td class="align-middle text-center">
            {{ numeral(totaleRedditi(i)).format() }} €
          </td>
          <td class="align-middle text-center">
            {{ !i.handicap || i.handicap == 'false' ? 'No' : 'Si' }}
          </td>
        </tr>
        <tr v-if="!rows || !rows.length">
          <td
            :colspan="!isOpen ? '9' : '10'"
            class="text-center font-italic"
          >
            Nessun reddito dichiarato
          </td>
        </tr>
      </tbody>
    </table>

    <redditi-patrimonio-modal ref="modal" />

  </div>
</template>

<script>
import numeral from 'numeral'
import moment from 'moment'
import redditiPatrimonioModal from '@/components/RedditiPatrimonioModal'

export default {
  name: 'redditiPatrimonioTable',
  components: {
    redditiPatrimonioModal
  },
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    numeral () {
      return numeral
    },
    moment () {
      return moment
    },
    isOpen () {
      // return this.item.stato === 'A'
      // console.log('(Redditi) Se dichiarazione P o B: ', this.item.stato, this.item.stato === 'B' || this.item.stato === 'P')
      // return this.item.stato === 'B'
      return this.item.stato === 'B' || this.item.stato === 'P'
    },
    rows () {
      return this.item.redditi
    }
  },
  methods: {
    apriForm (idx) {
      this.$refs.modal.open({ item: this.item, idx })
    },
    totaleRedditi (riga) {
      return Number(riga.importoRedditiDipendente) + Number(riga.importoRedditiAutonomo) + Number(riga.importoRedditiAltri) + Number(riga.importoRedditiNonImp)
    }

  }
}
</script>
